import React, {Component} from 'react'

import WordPressContainer from "../WordPressContainer"


export default class HomePage extends Component {
   componentDidMount() {
   }

   render() {
      return (
         <div className="container">
            <section className="padding-bottom">
               {/* HERO */}
               <WordPressContainer slug="startseite"/>
            </section>
         </div>
      )
   }
}



// WEBPACK FOOTER //
// ./src/pages/HomePage.js